var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pngUrl)?_c('img',{staticClass:"goodLeft",attrs:{"src":_vm.pngUrl,"alt":""}}):_c('img',{staticClass:"goodLeft",attrs:{"src":require("@/assets/img/notPng.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }